<template>
  <div class="table-wrapper" unselectable="on">
    <LoaderWait v-show="loading"/>
    <table class="main-table">
      <tr>
        <td class="td-logo" width="30%"><img src="/imgs/logo_impay.png"></td>
        <td colspan="2"></td>
      </tr>
      <tr>
        <td class="td-row" colspan="3" align="center">
          <div class="input-head-text">История операций</div>
        </td>
      </tr>
      <tr>
        <td class="td-row" colspan="3" align="center">
          <table style="border: 0; width: 100%;" cellpadding="8px">
            <tr v-for="(item, k) in historyListPage" :key="k">
                <td width="70%" class="">
                  <div class="info-text">{{item.date}}</div>
                  <div class="main-text" style="padding-bottom: 20px;">{{item.info}}</div>
                </td>
                <td width="30%" align="right">
                  <div class="main-text">{{item.amount/100}} руб.</div>
                </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr>
        <td class="td-nav" width="30%">
          <img @click="backClick" src="/imgs/back_1.png">
        </td>
        <td class="td-nav" width="50%" align="center">
          <img @click="mainClick" src="/imgs/menu_impay_1.png">
        </td>
        <td class="td-nav" width="30%" align="right">
          <img @click="fwdClick" src="/imgs/fwd_1.png" v-show="hasMoreData">
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import LoaderWait from "@/components/LoaderWait.vue";

export default {
  name: "HistoryPage",
  components: { LoaderWait },
  data () {
    return {
      loading: false,
      timer: null,
      maxItems: 6,
      page: 0,
    }
  },
  computed: {
    user () {
      const data = this.$store.getters.GET_USER_PROFILE
      if (data !== null) {
        return data
      } else {
        return null
      }
    },
    historyList () {
      const data = this.$store.getters.HIST_LIST
      if (data !== null) {
        return data
      } else {
        return null
      }
    },
    historyListPage () {
      const data = this.historyList
      if (data !== null) {
        let listPart = []
        for (let i = 0; i < this.maxItems; i++) {
          let idx = i + this.page * this.maxItems;
          if (this.historyList.length > idx) {
            listPart[i] = this.historyList[idx]
          }
        }
        return listPart;
      } else {
        return null
      }
    },
    hasMoreData() {
      if (this.historyList !== null) {
        return this.historyList > (this.page + 1) * this.maxItems;
      }
      return false;
    }
  },
  async mounted () {
    this.updateTimer()
    await this.loadHistory();
  },
  methods: {
    async loadHistory() {
      this.$store.dispatch('GET_HIST_LIST', {
        phone: this.user.phone,
      }).catch((e) => {
        if (e.response !== undefined && e.response.status === 401) {
          this.$store.dispatch('AUTH_LOGOUT')
        }
      })
    },
    updateTimer() {
      this.stopTimer()
      this.timer = setTimeout(() => this.timerExit(), 60000)
      console.log('updateTimer main')
    },
    stopTimer() {
      console.log('stopTimer main')
      if (this.timer !== null) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    timerExit() {
      this.$store.dispatch('AUTH_LOGOUT')
    },
    backClick() {
      if (this.page > 0) {
        this.updateTimer()
        this.page--
      } else {
        this.stopTimer()
        this.$router.go(-1)
      }
    },
    mainClick() {
      this.stopTimer()
      this.$router.go(-1)
    },
    fwdClick() {
      this.updateTimer()
      console.log(this.historyList.length);
      console.log((this.page + 1) * this.maxItems)
      if (this.historyList.length > (this.page + 1) * this.maxItems) {
        this.page++
      }
    }
  }
}
</script>

<style scoped>

</style>
